import { List, Map } from 'immutable';

import * as D from './deps';

export function buildPlaylistObject({ audioTrack, repeat, shuffle }) {
  const id = audioTrack.get('sourceId');
  const type = D.Utils.SourceType.getSourceTypeFromPandoraId(id);
  return {
    id,
    type,
    index: 0,
    tracks: List.of(audioTrack.get('pandoraId')),
    repeat,
    shouldShuffle: shuffle,
    trackModel: 'APSItem',
  };
}

export function mapItemToSessionItem(item) {
  return Map({
    sourceId: item.sourceId,
    pandoraId: item.pandoraId,
    index: item.index,
    trackToken: item.trackToken,
    interactions: item.interactions,
    rating: item.rating,
    type: item.type,
  });
}

export function mapItemToAudioTrack(item) {
  let track = Map(item);
  const audioEncoding = D.getInDomain('playback.utils.getAudioEncoding')(track);
  const albumArt = track.get('albumArt');
  const icon = track.get('icon');
  const narrative = track.get('narrative');
  if (narrative && !Map.isMap(narrative)) {
    track = track.set('narrative', Map(narrative));
  }

  track = track.set('audioEncoding', audioEncoding);
  // TODO once all sources are served through APS, references to audioURL should be updated to audioUrl so this can go away
  track = track.set('audioURL', track.get('audioUrl'));
  track = track.set('trackToken', track.get('pandoraId'));

  if (albumArt && !List.isList(albumArt)) {
    track = track.set('albumArt', List(albumArt.map(at => (Map.isMap(at) ? at : Map(at)))));
  }

  if (icon && !Map.isMap(icon)) {
    track = track.set('icon', Map(icon));
  }

  return track;
}
